// Shared motion language for the whole site.
// One easing, consistent durations — sections compose these instead of
// declaring their own ad-hoc variants.

export const EASE = [0.22, 1, 0.36, 1];

// container that staggers its children
export const stagger = (staggerChildren = 0.11, delayChildren = 0.1) => ({
  hidden: {},
  show: { transition: { staggerChildren, delayChildren } },
});

// soft rise — for cards, rows, media (no blur: cheap on GPU)
export const rise = {
  hidden: { opacity: 0, y: 28, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.65, ease: EASE },
  },
};

// blur-up — for text blocks and headings (serif looks great sharpening in)
export const blurUp = {
  hidden: { opacity: 0, y: 22, filter: "blur(8px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.7, ease: EASE },
  },
};

// line-mask reveal — wrap in an overflow:hidden parent
export const lineUp = {
  hidden: { y: "115%" },
  show: { y: "0%", transition: { duration: 0.9, ease: EASE } },
};

// horizontal rule growing from the left
export const ruleGrow = {
  hidden: { scaleX: 0 },
  show: { scaleX: 1, transition: { duration: 0.7, ease: EASE } },
};
